import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";
import React, { useContext, useEffect, useState } from "react";

export const OthersProducts = ({
  item,
  productsToShoppin,
  setProductsToShoppin,
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const [counter, setCounter] = useState(1);

  useEffect(() => {
    const productIndex = productsToShoppin.findIndex(
      (product) => product.adicionalsId === item.adicionalsId
    );
    if (productIndex !== -1) {
      // Copiar el array de productos
      const updatedToShoppin = [...productsToShoppin];
      // Actualizar el contador del producto específico
      updatedToShoppin[productIndex].quantity = counter;
      // Actualizar el estado global con el nuevo array
      setProductsToShoppin(updatedToShoppin);
    }
  }, [counter]);

  const handdleChange = (e) => {
    if (e.target.checked) {
      setIsChecked(true);
      const newItem = { ...item };
      item.quantity = counter;
      setProductsToShoppin([...productsToShoppin, newItem]);
    } else {
      setIsChecked(false);
      setProductsToShoppin(
        productsToShoppin.filter((product) => product.id !== item.id)
      );
    }
  };

  return (
    <label className=" grid grid-flow-col grid-cols-[2fr_5fr_2fr_25px] gap-1  w-full min-w-[245px] border border-gray p-1 pt-0 rounded-xl drop-shadow-lg cursor-pointer">
      <figure className=" max-w-[150px] min-w-[55px] flex rounded-xl place-self-center p-1	">
        <img
          loading="lazy"
          className=" place-self-center object-contain rounded-xl  "
          src={item.images.small}
          alt={item.name}
        />
      </figure>
      <span className=" flex flex-col self-center">
        <h2 className=" font-bold text-base  text-start mr-2 pl-2">
          {item.name}
        </h2>
        <p className="font-semibold text-xs mr-2 absolute bottom-1 pl-2">
          {item.tamaño ? item.tamaño : null}
        </p>
        <p className="font-semibold place-self-end text-sm mr-2">
          ${item.price.toLocaleString(undefined, { minimumFractionDigits: 0 })}
        </p>
      </span>
      {isChecked ? (
        <span
          className=" flex self-center mr-2  gap-2 border-[1px] border-gray-300 pointer-events-none"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            className=" w-6 text-center font-extrabold border-r-[1px] border-gray-300 bg-gray-200 pointer-events-auto"
            onClick={() => {
              counter !== 1 && setCounter(counter - 1);
            }}
          >
            <MinusIcon className=" text-black " />
          </button>
          <p className="font-semibold text-lg">{counter}</p>
          <button
            className=" w-6  text-center font-extrabold border-r-[1px] border-gray-300 bg-gray-200 pointer-events-auto"
            onClick={() => {
              setCounter(counter + 1);
            }}
          >
            <PlusIcon className=" text-black " />
          </button>
        </span>
      ) : (
        <span></span>
      )}
      <input
        className="w-[20px] h-[20px] self-center cursor-pointer"
        type="checkbox"
        name={item.name}
        id={item.id}
        onChange={(e) => handdleChange(e)}
      />
    </label>
  );
};
